exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#profile-menu {\n  max-width: 400px;\n  width: 100%;\n}\n#profile-menu .menu-nav-item-content {\n  padding: 5px 0;\n}", ""]);

// exports
